export default "__VITE_ASSET__0b747bcf__"